import React, { createContext, useContext, useEffect, useState } from 'react';
import {
	editThresholdCapitalMarket,
	getBoxPlotChartDataCapitalMarket,
	getBreakDownFilterColumnsForCapitalMarket,
	getBreakDownFilterForCapitalMarket,
	getLineChartChartDataCapitalMarket,
	getThresholdCapitalMarket,
	updateCapitalMarketSettings,
	getCapitalMarketDateRange,
} from 'utils/apiRequests';
import { generateToolTip } from 'utils/filterNames';
import { getFormattedSpendWithSymbol } from 'utils/number';
import {
	getDateFormat,
	getDateRangeMonthYearState,
} from 'CategoryManagement/utils';

const WorkingCapitalFilters = createContext();
function calculateWhiskersAndHinges(data) {
	return data.map(item => ({
		dimension: item.dimension,
		lower_Hinge: item.minDPO,
		lower_whisker: item.minDPO * 0.99,
		median: (item.minDPO + item.maxDPO) / 2,
		upper_hinge: item.maxDPO,
		upper_whisker: item.maxDPO * 1.1,
		realizedTerm: item.realizedTerm,
		minDPO: item.minDPO,
		maxDPO: item.maxDPO,
		tooltip: generateToolTip({
			Dimension: item.dimension,
			'Maximum Contract Term': item.maxDPO,
			'Minimum Contract Term': item.minDPO,
			'Weighted Average': item.realizedTerm,
			'Amount Paid': getFormattedSpendWithSymbol(
				item.amtPaid,
				'$',
				true
			).toUpperCase(),
		}),
	}));
}
export const WorkingCapitalFiltersProvider = ({ children }) => {
	const [breakDownFilters, setbreakDownFilters] = useState([]);
	const [currentBreakDownFilter, setCurrentBreakDownFilter] = useState([]);
	const [currentFilterOptions, setcurrentFilterOptions] = useState([]);
	const [
		currentFilterValuesSelected,
		setcurrentFilterValuesSelected,
	] = useState([]);
	const [currentSelectedYear, setCurrentSelectedYear] = useState({
		label: '2020',
		value: '2020',
	});
	const [boxPlotData, setboxPlotData] = useState([]);
	const [lineChartData, setLineChartData] = useState([]);
	const [filterSettings, setFilterSettings] = useState();
	const [isSaving, setIsSaving] = useState(false);
	const [dayDiff, setDayDiff] = useState('');
	const [thresholdFilterSettings, setThresholdFilterSettings] = useState({
		pcardThreshold: null,
		extendTermThreshold: null,
		SelectBySpendThresholdLow: null,
		SelectBySpendThresholdHigh: null,
		spendThreshold: null,
	});
	const [dateRangeData, setDateRangeData] = useState('');

	// Function to calculate the difference in days between two dates in YYYY-MM-DD format
	function dayDifference(fromDateStr, toDateStr) {
		// Convert date strings into Date objects
		let fromDate = new Date(fromDateStr);
		let toDate = new Date(toDateStr);

		// Calculate the difference in milliseconds
		let timeDiff = toDate - fromDate;

		// Convert milliseconds to days
		let dayDiff = timeDiff / (1000 * 3600 * 24);

		return Math.floor(dayDiff); // Return the difference in full days
	}

	useEffect(
		() => {
			if (currentBreakDownFilter.value) {
				const payload = {
					dimension: currentBreakDownFilter.value,
					dateFrom: dateRangeData.dateFrom,
					dateTo: dateRangeData.dateTo,
				};
				getBreakDownFilterForCapitalMarket(payload)
					.then(response => {
						setcurrentFilterOptions(
							response.map(data => ({ label: data, value: data }))
						);
						if (response.length === 1 && response[0] !== null) {
							setcurrentFilterValuesSelected([response[0]]);
						}
					})
					.catch(error => {
						console.log(error, 'Error Message');
					});
			}
		},
		[currentBreakDownFilter, dateRangeData]
	);

	useEffect(() => {
		getCapitalMarketDateRange()
			.then(response => {
				const dateFrom = `${response.srcRange.from.year}-${String(
					response.srcRange.from.month
				).padStart(2, '0')}-01`;

				function getLastDayOfMonth(year, month) {
					const date = new Date(year, month, 0);
					return date.getDate();
				}

				const lastDay = getLastDayOfMonth(
					response.srcRange.to.year,
					response.srcRange.to.month
				);

				const dateTo = `${response.srcRange.to.year}-${String(
					response.srcRange.to.month
				).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;

				const selectedRange = getDateRangeMonthYearState(dateFrom, dateTo);
				let diff = dayDifference(dateFrom, dateTo);
				setDayDiff(diff);
				setDateRangeData({
					srcRange: response.srcRange,
					stateRange: selectedRange,
					dateFrom: dateFrom,
					dateTo: dateTo,
				});
				getFilters();
			})
			.catch(error => {
				console.log(error, 'Error Message');
			});
		getThresholdCapitalMarket()
			.then(response => {
				setThresholdFilterSettings({
					extendTermThreshold: response.ExtendTermThreshold,
					pcardThreshold: response.PcardThreshold,
					SelectBySpendThresholdLow: response.SelectBySpendThresholdLow,
					SelectBySpendThresholdHigh: response.SelectBySpendThresholdHigh,
					spendThreshold: response.SpendThreshold,
				});
			})
			.catch(error => {
				console.log(error, 'Error Message');
			});
	}, []);
	const getFilters = async () => {
		const responseForFilters = await getBreakDownFilterColumnsForCapitalMarket();
		let formattedResponseFilters = responseForFilters.map(item => {
			item.label = item.label.split('_').join(' ');
			return item;
		});
		setbreakDownFilters(
			formattedResponseFilters.filter(data => data.isEnabled)
		);
		setFilterSettings(formattedResponseFilters);
		setCurrentBreakDownFilter(
			formattedResponseFilters.filter(data => data.isEnabled)[0]
		);
	};
	const handleFilterByChange = e => {
		setCurrentBreakDownFilter(e);
		setcurrentFilterValuesSelected([]);
	};

	const getDashBoardBoxPlotByBreakDown = async value => {
		const payload = {
			dimension: value,
			dateFrom: dateRangeData.dateFrom,
			dateTo: dateRangeData.dateTo,
		};
		const responseBoxPlotData = await getBoxPlotChartDataCapitalMarket(payload);
		setboxPlotData(calculateWhiskersAndHinges(responseBoxPlotData));
	};
	const getDashBoardLineChartByBreakDown = async value => {
		const payload = {
			dimension: value,
			dateFrom: dateRangeData.dateFrom,
			dateTo: dateRangeData.dateTo,
		};
		const responseLineChartData = await getLineChartChartDataCapitalMarket(
			payload
		);
		setLineChartData(responseLineChartData);
	};
	const updateFilterSettings = async (params, func1) => {
		const { rowData } = params.agGridReact.props;
		const newFilters = rowData.map(data => {
			const filterdata = data;
			filterdata.label = filterdata.label.split(' ').join('_');
			if (params.data.value === data.value) {
				filterdata.isEnabled = !filterdata.isEnabled;
			}
			return filterdata;
		});
		await updateCapitalMarketSettings(newFilters)
			.then(() => getFilters())
			.then(() => {
				func1(state => !state);
				func1(state => !state);
			});
	};
	const saveThresholdFilters = async (setCloseSettings, handleRefreshGrid) => {
		setIsSaving(true);
		let payload = {
			PcardThreshold: thresholdFilterSettings.pcardThreshold,
			ExtendTermThreshold: thresholdFilterSettings.extendTermThreshold,
			SelectBySpendThresholdLow:
				thresholdFilterSettings.SelectBySpendThresholdLow,
			SelectBySpendThresholdHigh:
				thresholdFilterSettings.SelectBySpendThresholdHigh,
			SpendThreshold: thresholdFilterSettings.spendThreshold,
		};
		await editThresholdCapitalMarket(payload);
		setIsSaving(false);
		setCloseSettings(false);
		handleRefreshGrid('Refresssed');
	};

	const handleDateRangeChange = value => {
		const minMaxDates = getDateFormat(value);
		let diff = dayDifference(minMaxDates.dateFrom, minMaxDates.dateTo);
		setDayDiff(diff);
		setDateRangeData(prevState => ({
			...prevState,
			stateRange: value,
			...minMaxDates,
		}));
	};

	return (
		<WorkingCapitalFilters.Provider
			value={{
				isLoading: false,
				currentBreakDownFilter,
				setCurrentBreakDownFilter,
				currentFilterOptions,
				setcurrentFilterOptions,
				currentFilterValuesSelected,
				setcurrentFilterValuesSelected,
				handleFilterByChange,
				breakDownFilters,
				setCurrentSelectedYear,
				currentSelectedYear,
				getDashBoardBoxPlotByBreakDown,
				boxPlotData,
				getDashBoardLineChartByBreakDown,
				lineChartData,
				updateFilterSettings,
				filterSettings,
				thresholdFilterSettings,
				setThresholdFilterSettings,
				saveThresholdFilters,
				isSaving,
				setIsSaving,
				dateRangeData,
				handleDateRangeChange,
				dayDiff,
			}}
		>
			{children}
		</WorkingCapitalFilters.Provider>
	);
};

export const useWorkingCapitalFiltersContext = () => {
	return useContext(WorkingCapitalFilters);
};
